module.exports = __webpack_public_path__ + "static/img/inviteTitle.938de9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/inviteTitle.png
// module id = 917
// module chunks = 1